import { Component } from '@angular/core';

@Component({
  selector: 'bspk-touch-target',
  imports: [],
  templateUrl: './touch-target.component.html',
  styleUrl: './touch-target.component.scss',
  host: {
    '[attr.data-touch-target]': 'true',
  },
})
export class BspkTouchTarget {}
